export default {
    series: 1,
    data: 'Name;Value\nAfrica;5000\nAmerica;4000\nAsia;3000\nEurope;2000',
    seriesMapping: [
      {
        name: 0,
        value: 1,
      },
    ],
};